import React from "react";
import { Collapse, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Panel } = Collapse;

const InfoCollapse = ({ title, description }) => {
  return (
    <Collapse ghost showArrow={false}>
      <Panel
        header={
          <Tooltip title="Click for more information">
            <span style={{ color: "blue" }}>
              {title}
              <InfoCircleOutlined style={{ marginLeft: "5px" }} />
            </span>
          </Tooltip>
        }
        key="1"
        showArrow={false}
      >
        {description}
      </Panel>
    </Collapse>
  );
};

export default InfoCollapse;
